import React from 'react';

const EventDetails: React.FC = () => {
  return (
    <section id="details" className="py-12 md:py-20 bg-white">
      <div className="container mx-auto px-4 md:px-6">
        <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl text-center text-wedding-navy mb-8 md:mb-16">
          Wedding Details
        </h2>

        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-6 md:gap-12">
          <div className="bg-wedding-cream p-6 md:p-8 rounded-lg shadow-lg">
            <div className="text-center mb-4 md:mb-6">
              <div className="inline-block p-3 md:p-4 bg-wedding-gold rounded-full mb-3 md:mb-4">
                <svg
                  className="w-8 h-8 text-white"
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
              </div>
              <h3 className="font-serif text-2xl sm:text-3xl text-wedding-navy mb-2">Ceremony</h3>
            </div>
            <div className="space-y-2 md:space-y-3 text-center">
              <p className="text-base md:text-lg">
                <span className="font-semibold">Date:</span> June 26, 2027
              </p>
              <p className="text-lg">
                <span className="font-semibold">Time:</span> 4:00 PM
              </p>
              <p className="text-lg">
                <span className="font-semibold">Location:</span>
              </p>
              <p className="text-gray-700 text-sm md:text-base">
                Beachfront Ceremony
                <br />
                Punta Cana, Dominican Republic
              </p>
              <p className="text-sm text-gray-600 mt-4">
                <span className="font-semibold">Dress Code:</span> Formal
              </p>
            </div>
          </div>

          <div className="bg-wedding-cream p-6 md:p-8 rounded-lg shadow-lg">
            <div className="text-center mb-4 md:mb-6">
              <div className="inline-block p-3 md:p-4 bg-wedding-gold rounded-full mb-3 md:mb-4">
                <svg
                  className="w-8 h-8 text-white"
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
              </div>
              <h3 className="font-serif text-2xl sm:text-3xl text-wedding-navy mb-2">Reception</h3>
            </div>
            <div className="space-y-2 md:space-y-3 text-center">
              <p className="text-base md:text-lg">
                <span className="font-semibold">Date:</span> June 26, 2027
              </p>
              <p className="text-lg">
                <span className="font-semibold">Time:</span> 6:00 PM - 12:00 AM
              </p>
              <p className="text-lg">
                <span className="font-semibold">Location:</span>
              </p>
              <p className="text-gray-700 text-sm md:text-base">
                Oceanview Terrace
                <br />
                Dinner, Dancing & Celebration
              </p>
              <p className="text-sm text-gray-600 mt-4">
                Cocktail hour begins at 5:30 PM
              </p>
              <p className="text-sm text-gray-600 mt-2">
                <span className="font-semibold">Dress Code:</span> Formal
              </p>
            </div>
          </div>
        </div>

        <div className="mt-8 md:mt-16 text-center">
          <div className="inline-block bg-wedding-gold bg-opacity-10 border-2 border-wedding-gold p-4 md:p-6 rounded-lg">
            <p className="text-wedding-navy text-sm sm:text-base md:text-lg">
              This is a <span className="font-semibold">destination wedding</span>!
              <br />
              Please see the Travel section for accommodation details.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EventDetails;
